import axios from "axios";
import Cookies from 'js-cookie'

export const  apiErrorHandler = (err) => {
    // console.log(err,' err ');
    // axios.interceptors.response.use(response => {
    //     console.log(response, ' response ');
    //     // return response;
    //  }, error => {
    //    console.log(error, 'api error')
    //     if(error.response.statusText === 'Unauthorized'){
    //         // console.log(error, 'err response', window.location.origin);
    //         localStorage.clear();
    //         Cookies.remove('token');
    //         Cookies.remove('UserAuth');
    //         Cookies.remove('userData');
    //         // Cookies.remove('username');
    //         // Cookies.remove('name');
    //         // Cookies.remove('selectedPlot');
    //         // Cookies.remove('userSignData');
    //         // Cookies.remove('selectedCycle');
    //         // Cookies.remove('selectedFarm');
    //         window.location.replace(window.location.origin);
    //         window.location.reload();
    //     }
    //     else {
            
    //     }
    //    return null;
    //  });

    //  axios.interceptors.request.use(function (config) {
    //   console.log(config,"axios.interceptors.reques")
    // }, function (error) {
    // });

    // // Add a response interceptor
    // axios.interceptors.response.use(function (response) {
    //   console.log(response,"axios.interceptors.response")
    //   // return response;
    // }, function (error) {

    //   // return Promise.reject(error);
    // });
}

export const SessionExpiredHandler = () => {
  localStorage.clear();
  Cookies.remove('token');
  Cookies.remove('UserAuth');
  Cookies.remove('userData');
//   Cookies.remove('username');
//   Cookies.remove('name');
//   Cookies.remove('selectedPlot');
//   Cookies.remove('userSignData');
//   Cookies.remove('selectedCycle');
//   Cookies.remove('selectedFarm');
  window.location.replace(window.location.origin);
  window.location.reload();
}